import { AxiosResponse } from "axios";

import { IQuartzJobsOverview } from "../../@types/admin/AdminQuartzJobs";
import { api } from "../api";

/**
 * Scheduled Jobs (Quartz) overview for the admin portal. Read-only: the
 * endpoint lists every Quartz job and trigger in this region's scheduler with
 * the workflow / ward / hospital / tenant each one serves. Nothing here can
 * pause, resume or delete a job.
 *
 * The page reads the whole (unfiltered) overview once and filters
 * client-side; the API's own query filters exist for scripted use.
 */
export const quartzJobsService = {
  /** Every job and trigger in the scheduler, with context and warnings. */
  async getOverview(): Promise<AxiosResponse<IQuartzJobsOverview>> {
    return api.get<IQuartzJobsOverview>("/Retool/QuartzJobs");
  },
};
